function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "calendar-x_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "calendar-x_svg__Rectangle_6583",
  fill: "#ca3612",
  stroke: "#707070",
  d: "M0 0h25v25H0z",
  transform: "translate(-.206)"
})), /*#__PURE__*/React.createElement("style", null));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calendar-x_svg__Mask_Group_215",
  clipPath: "url(#calendar-x_svg__clip-path)",
  transform: "translate(.206)"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar-x_svg__reservation",
  transform: "translate(.001 .001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "calendar-x_svg__Group_19383",
  transform: "translate(.777 .677)"
}, /*#__PURE__*/React.createElement("path", {
  id: "calendar-x_svg__Path_6888",
  fill: "#ca3612",
  d: "M20.671 1.417v1.057H5.7V1.417H4.626v1.057H1.417v21.151H24.95V2.474h-3.209V1.417zm0 4.23h1.07V3.532h2.139v19.036H2.486V3.532h2.14v2.115H5.7V3.532h14.971v2.115zM22.81 6.7H3.556v1.062H22.81V6.7zm-6.692 5.34L11.5 16.807l.825-1.1-.315.469-.99 1.639v-.388l5.093-5.391h-.37l.251.144z",
  transform: "translate(-1.417 -1.417)"
}), /*#__PURE__*/React.createElement("path", {
  id: "calendar-x_svg__Line_449",
  d: "M0 0l7.551 7.465",
  className: "calendar-x_svg__x",
  transform: "translate(7.614 10.513)"
}), /*#__PURE__*/React.createElement("path", {
  id: "calendar-x_svg__Line_450",
  d: "M7.551 0L0 7.465",
  className: "calendar-x_svg__x",
  transform: "translate(7.614 10.513)"
}))));

function SvgCalendarX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    className: "icon"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1Ij4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcC1wYXRoIj4KICAgICAgICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV82NTgzIiBmaWxsPSIjY2EzNjEyIiBzdHJva2U9IiM3MDcwNzAiIGQ9Ik0wIDBIMjVWMjVIMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMjA2KSIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgICAgIDxzdHlsZT4KICAgICAgICAgICAgLmNscy00e2ZpbGw6bm9uZTtzdHJva2U6I2NhMzYxMjtzdHJva2Utd2lkdGg6MS41cHh9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJNYXNrX0dyb3VwXzIxNSIgY2xpcC1wYXRoPSJ1cmwoI2NsaXAtcGF0aCkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC4yMDYpIj4KICAgICAgICA8ZyBpZD0icmVzZXJ2YXRpb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC4wMDEgLjAwMSkiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXBfMTkzODMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC43NzcgLjY3NykiPgogICAgICAgICAgICAgICAgPHBhdGggaWQ9IlBhdGhfNjg4OCIgZmlsbD0iI2NhMzYxMiIgZD0iTTIwLjY3MSAxLjQxN3YxLjA1N0g1LjdWMS40MTdINC42MjZ2MS4wNTdIMS40MTd2MjEuMTUxSDI0Ljk1VjIuNDc0aC0zLjIwOVYxLjQxN3ptMCA0LjIzaDEuMDdWMy41MzJoMi4xMzl2MTkuMDM2SDIuNDg2VjMuNTMyaDIuMTR2Mi4xMTVINS43VjMuNTMyaDE0Ljk3MXYyLjExNXpNMjIuODEgNi43SDMuNTU2djEuMDYySDIyLjgxVjYuN3ptLTYuNjkyIDUuMzRMMTEuNSAxNi44MDdsLjgyNS0xLjEtLjMxNS40NjktLjk5IDEuNjM5di0uMzg4bDUuMDkzLTUuMzkxaC0uMzdsLjI1MS4xNDR6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS40MTcgLTEuNDE3KSIgLz4KICAgICAgICAgICAgICAgIDxwYXRoIGlkPSJMaW5lXzQ0OSIgZD0iTTAgMEw3LjU1MSA3LjQ2NSIgY2xhc3M9IngiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcuNjE0IDEwLjUxMykiIC8+CiAgICAgICAgICAgICAgICA8cGF0aCBpZD0iTGluZV80NTAiIGQ9Ik03LjU1MSAwTDAgNy40NjUiIGNsYXNzPSJ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjYxNCAxMC41MTMpIiAvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgCalendarX as ReactComponent };